import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query getSubjectOnBoardAnalysis($filter: onBoardAnalysisFilterInput) {
    getSubjectOnBoardAnalysis(filter: $filter) {
      totalMaleSubjectCount
      totalFemaleSubjectCount
      totalThirdSubjectCount
      vincenseMaleSubjectCount
      vincenseFemaleSubjectCount
      vincenseThirdSubjectCount
      subjectKeyCountList {
        subjectKey {
          id
          name
          priorityOrder
        }
        maleSubjectCount
        femaleSubjectCount
        thirdSubjectCount
      }
      remarkList {
        remark
        datetime
        user {
          name
        }
      }
    }
  }
`;

const initialState: TYPES.OnBoardStatState = {
  result: null,
  error: null,
  loading: false
};

export const getSubjectOnBoardAnalysisRequest = createAsyncThunk<
  TYPES.OnBoardStat,
  {filter?: TYPES.OnBoardAnalysisFilterInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject/get_subject_on_board_analysis',
  async (
  params: {filter?: TYPES.OnBoardAnalysisFilterInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getSubjectOnBoardAnalysis;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getSubjectOnBoardAnalysisSlice = createSlice({
  name: 'get_subject_on_board_analysis',
  initialState: initialState,
  reducers: {
    getSubjectOnBoardAnalysisClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getSubjectOnBoardAnalysisRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      getSubjectOnBoardAnalysisRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      getSubjectOnBoardAnalysisRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { getSubjectOnBoardAnalysisClear } =
getSubjectOnBoardAnalysisSlice.actions;

export const getSubjectOnBoardAnalysis = createSelector(
  (state: RootState) => state.subject.getSubjectOnBoardAnalysis.result,
  (state: RootState) => state.subject.getSubjectOnBoardAnalysis.error,
  (state: RootState) => state.subject.getSubjectOnBoardAnalysis.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getSubjectOnBoardAnalysisSlice.reducer;